var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.wrapClass }, [
    _vm.imageModel.hasCrop
      ? _c("div", { staticClass: "image-cover-wrap" }, [
          _c("picture", [
            _c("source", {
              attrs: {
                "data-srcset": _vm.imageModel.srcSetWebP,
                type: "image/webp",
                "data-sizes": "auto",
              },
            }),
            _vm._v(" "),
            _c("source", {
              attrs: {
                "data-srcset": _vm.imageModel.srcSet,
                type: _vm.imageModel.type,
                "data-sizes": "auto",
              },
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "image-cover lazyload",
              style: _vm.imageModel.style,
              attrs: {
                src: _vm.imageModel.src,
                "data-src": _vm.imageModel.dataSrc,
                alt: _vm.imageModel.altText,
                "data-sizes": "auto",
              },
            }),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.imageModel.hasCrop
      ? _c("img", {
          staticClass: "image-cover lazyload",
          style: _vm.imageModel.style,
          attrs: {
            src: _vm.imageModel.src,
            "data-src": _vm.imageModel.dataSrc,
            alt: _vm.imageModel.altText,
          },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/scripts/vue/components/responsiveImage.vue